// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore, ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import { UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import {
    chain,
    UpdateCart,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetCheckoutPaymentMethod";
import { PaymentMethodDto } from "@insite/client-framework/Types/ApiModels";
import { updateCartTermsCode } from "@rc/App/Services/checkoutServices";

type HandlerType = ApiHandlerDiscreteParameter<{ paymentMethod?: PaymentMethodDto }, UpdateCartApiParameter>;

export const UpdateCartTermsCode: HandlerType = async props => {
    const paymentMethodName = props.parameter.paymentMethod?.name || "";
    if (paymentMethodName) {
        await updateCartTermsCode({ termsCode: paymentMethodName });
    }
};

addToChainBefore(chain, UpdateCart, UpdateCartTermsCode);
